import React, { useState, useContext } from 'react';

import UserContext from '@context/UserContext'
import InputField from '@components/common/InputField';

const Form = ({handleForgotPassword}) => {
    const [email, setEmail] = useState("")
    const [password, setPassword] = useState("")
    const [showPassword, setShowPassword] = useState(false)
    const [error, setError] = useState("")
    const [isSubmitting, setIsSubmitting] = useState(false)

    const { newlyRegistered, setLoginSuccess, setIsLoggedIn, login } = useContext(UserContext)

    const handleSubmit = async (e) => {
        e.preventDefault();
        setIsSubmitting(true);
        
        const response = await login(email, password);

        if (response?.errors?.length > 0) {
            setError(response?.errors?.[0]?.message);
        } else {
            if (response?.data?.customerAccessTokenCreate?.userErrors?.length > 0) {
                const error = response?.data?.customerAccessTokenCreate?.userErrors?.[0]?.message;

                if(error) {
                    setError("Incorrect Email Address / Password.");
                }
                
            } else {
                setLoginSuccess(true)
                setIsLoggedIn(true);
            }
        }

        setIsSubmitting(false);
    }

    const validateForm = () => {
		return email.trim() === "" || password.trim() === ""
	}

	return (
        <React.Fragment>
            <form onSubmit={handleSubmit} className="space-y-4">
                {
                    newlyRegistered ?
                        <div className="flex items-center p-4 mb-4 text-sm text-green-800 border border-green-300 rounded-lg bg-green-50 dark:text-green-400 dark:border-green-800" role="alert">
                            <svg className="shrink-0 inline w-4 h-4 me-3" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 20 20">
                                <path d="M10 .5a9.5 9.5 0 1 0 9.5 9.5A9.51 9.51 0 0 0 10 .5ZM9.5 4a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3ZM12 15H8a1 1 0 0 1 0-2h1v-3H8a1 1 0 0 1 0-2h2a1 1 0 0 1 1 1v4h1a1 1 0 0 1 0 2Z"/>
                            </svg>
                            <span className="sr-only">Info</span>
                            <div>
                                <span className="font-medium">Registration successful! Please log in.</span> 
                            </div>
                        </div> : null
                }
                <div className={`space-y-3`}>
                        <InputField
                        id="userEmail"
                        label="Email Address"
                        placeholder=""
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                        aria-label={"enter email"}
                        labelOnTop
                        />

                    <div className="space-y-2">
                        <InputField
                            id="userPassword"
                            showPassword={showPassword}
                            setShowPassword={setShowPassword}
                            label="Password"
                            type={showPassword ? "text" : "password"}
                            placeholder=""
                            value={password}
                            onChange={(e) => setPassword(e.target.value)}
                            aria-label={"enter password"}
                            enableShowPasswordIcon
                            labelOnTop
                        />

                        <button
                            className="text-secondary float-right"
                            aria-label="forgot password"
                            onClick={handleForgotPassword}
                            type="button"
                        >
                            Forgot Password?
                        </button>
                    </div>
                </div>

                <button
                    type="submit"
                    className="w-full btn-primary mt-10"
                    disabled={validateForm() || isSubmitting}
                    aria-label="Login"
                >Login</button>

                {
                    error != "" ?
                        <div className="flex items-center p-4 mb-4 text-sm text-red-800 border border-red-300 rounded-lg bg-red-50  dark:text-red-400 dark:border-red-800" role="alert">
                            <svg className="shrink-0 inline w-4 h-4 me-3" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 20 20">
                                <path d="M10 .5a9.5 9.5 0 1 0 9.5 9.5A9.51 9.51 0 0 0 10 .5ZM9.5 4a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3ZM12 15H8a1 1 0 0 1 0-2h1v-3H8a1 1 0 0 1 0-2h2a1 1 0 0 1 1 1v4h1a1 1 0 0 1 0 2Z"/>
                            </svg>
                            <span className="sr-only">Info</span>
                            <div>
                                <span className="font-medium">{error}</span> 
                            </div>
                        </div> : null
                }
            </form>
        </React.Fragment>
    )
}

export default Form